
import { formatDateObject } from '@/utils/formUtils'
import { videoStatus, LiveStatus } from '@/json/index'
import { getEnumeration } from 'enumeration'
export function handleVideo (item) {
  item['recordingTime_copy'] = item.recordingTime ? formatDateObject(item.recordingTime) : '--'
  item['uploadTime_copy'] = item.uploadTime ? formatDateObject(item.uploadTime) : '--'
  item['createdDate_copy'] = item.createdDate ? formatDateObject(item.createdDate) : '--'
  item['releaseTime_copy'] = item.releaseTime ? formatDateObject(item.releaseTime) : '--'
  item['status_copy'] = item.status ? getEnumeration(item.status, videoStatus) : '--'
}
export function handleLive (item) {
  item['start_copy'] = item.start ? formatDateObject(item.start) : '--'
  item['end_copy'] = item.end ? formatDateObject(item.end) : '--'
  item['status_copy'] = item.status ? getEnumeration(item.status, LiveStatus) : '--'
}
